import React, {
    useState
} from 'react';

import { 
   IonPage,
   IonHeader,
   IonContent,
   IonToolbar,
   IonTitle,
   IonGrid,
   IonRow,
   IonCol,
   IonButtons,
   IonButton,
   IonBackButton,
   NavContext,
   IonCard,
   IonCardHeader,
   IonCardSubtitle,
   IonCardTitle,
   IonCardContent,
   IonImg,
   IonIcon,
   IonText,
   IonItem,
   useIonViewWillEnter,
   useIonRouter
} from '@ionic/react';
import { RouteComponentProps } from "react-router-dom";

import { shuffleOutline, cash } from "ionicons/icons";
import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";

interface NtkExSusProp extends RouteComponentProps<{
    usd : string,
    ntoken : string
    }> 
{} 

const NtkBuySuccess : React.FC<NtkExSusProp> = ({match}) => {

    //	Initializing our router
	const router = useIonRouter();

    const success = () => {
        router.push("/token/wallet", "back", "pop");
    }

    return (
        <IonPage>
            <IonContent>
                <div id="border-bk" />
                <IonGrid className="ion-no-padding full-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <div className="ion-text-center ion-padding">
                                <IonText><h5>{ GetStr(LANGUAGE.TXT_NTK_SUCCESS_CAP) }</h5></IonText>
                            </div>
                            <IonImg className="icon-pic" src="/assets/img/heart_pic.png" />

                            <IonCard className="flat-card">
                                <IonCardContent>
                                    <div>{ GetStr(LANGUAGE.TXT_NTK_SUCCESS_USD) }</div>
                                    <IonItem lines="none">
                                        <IonIcon icon={cash} slot="start"></IonIcon>
                                        <b>$ {match.params.usd}</b>
                                    </IonItem>
                                    <div>{ GetStr(LANGUAGE.TXT_NTK_SUCCESS_NTK) }</div>
                                    <IonItem lines="none">
                                        <IonIcon icon={shuffleOutline} slot="start"></IonIcon>
                                        <b>{match.params.ntoken}</b>
                                    </IonItem>
                                    <br/>
                                    <IonButton className="main-but ion-margin-top" color="primary" expand="block" onClick={success} >
                                        { GetStr(LANGUAGE.TXT_NTK_SUCCESS_BACK) }
                                    </IonButton>
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
}

export default NtkBuySuccess;